import { render } from "./ModelChildrenComponent.vue?vue&type=template&id=2aff1bd2"
import script from "./ModelChildrenComponent.vue?vue&type=script&lang=js"
export * from "./ModelChildrenComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__